(function () {
  const Core = window.RB.Core;
  const { equip, buff } = window.RB.CardLib;

  window.RB.CardScripts = window.RB.CardScripts || {};
  Object.assign(window.RB.CardScripts, {
    "Crowd Favorite": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          costXp: 2,
          label: "Crowd Favorite",
          targets: [],
          program: [{ op: "buff", to: "source" }],
        },
      ],
    },

    "Demacian Diplomat": { play: [{ op: "xp", n: 1 }] },

    "Dragonsoul Sage": {
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          exhausts: true,
          reaction: true,
          isAdd: true,
          program: [
            { op: "addResources", res: { energy: 1, pips: 0, anyPower: 0, domains: null } },
          ],
          label: "Add",
        },
      ],
    },

    "Gemhand Hunter": { selfMightSpecs: [{ n: 1, cond: { k: "xp", n: 6 } }] },

    "Hunter's Machete": {
      abilities: [
        equip({ energy: 0, pips: 1, anyPower: 0, domains: ["body"] }),
      ],
      attachedKw: [["hunt", null]],
    },

    "Master Yi, Tempered": {
      selfKwSpecs: [
        { name: "deflect", value: null, cond: { k: "xp", n: 6 } },
        { name: "ganking", value: null, cond: { k: "xp", n: 6 } },
      ],
    },

    "Nilah, Joyful Ascetic": {
      triggers: [
        {
          on: "move",
          optional: false,
          label: "When I move, gain 1 XP",
          targets: [],
          program: [{ op: "xp", n: 1 }],
          self: true,
        },
      ],
    },

    "Targonian Visionary": { selfMightSpecs: [{ n: 4, cond: { k: "xp", n: 11 } }] },

    "Towering Combatant": {},

    "Void Assault": {
      play: [
        { op: "move", to: "$t1", dest: "choose" },
        { op: "move", to: "$t2", dest: "choose" },
      ],
      targets: [
        { bind: "t1", spec: { type: "unit", friendly: true }, prompt: "Move..." },
        { bind: "t2", spec: { type: "unit", enemy: true }, prompt: "Move..." },
      ],
    },

    "Voracious Gromp": {},

    "Blood Rose": {
      triggers: [
        {
          on: "played",
          you: true,
          optional: true,
          label: "unit played: pay 1 Energy to gain 1 XP",
          condSpec: { k: "evType", type: "unit" },
          program: [
            { op: "payCost", cost: { energy: 1, pips: 0, anyPower: 0, domains: null }, skipOnFail: 1 },
            { op: "xp", n: 1 },
          ],
        },
      ],
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          costXp: 3,
          exhausts: true,
          label: "Spend 3 XP, exhaust: ready a unit",
          targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Ready which unit?" }],
          program: [{ op: "ready", to: "$t" }],
        },
      ],
    },

    "Call to Battle": {
      targets: [
        {
          bind: "u",
          spec: { type: "unit", friendly: true },
          prompt: "Move which unit you control?",
        },
        {
          bind: "b",
          spec: { zone: "battlefield", friendly: true },
          prompt: "Move it to which battlefield you control?",
        },
      ],
      play: [
        { op: "move", to: "$u", destRef: "$b" },
        {
          op: "choose",
          bind: "e",
          byOpponent: true,
          spec: { type: "unit", enemy: true, ignoreUntargetable: true },
          prompt: "Move which unit you control to that battlefield?",
        },
        { op: "move", to: "$e", destRef: "$b" },
      ],
    },

    "Clash of Giants": {
      targets: [
        { bind: "a", spec: { type: "unit" }, prompt: "Clash of Giants: first unit" },
        { bind: "b", spec: { type: "unit", notBind: "a" }, prompt: "Clash of Giants: second unit" },
      ],
      play: [{ op: "fight", a: "$a", b: "$b" }],
    },

    "Concentrate": {
      play: [{ op: "draw", n: 2 }],
      costMods: [
        {
          energyLess: 2,
          cond: { k: "and", conds: [{ k: "xp", n: 6 }, { k: "not", cond: { k: "xp", n: 11 } }] },
        },
        { energyLess: 4, cond: { k: "xp", n: 11 } },
      ],
    },

    "Determined Sentry": {
      restrictMove: [{ self: true, toBase: true }],
    },

    "Disposal Order": {
      play: [
        {
          op: "option",
          varKey: "mode",
          prompt: "Choose one",
          options: [
            "Choose up to 3 cards from opponents' trashes - their owners recycle them",
            "Draw 1",
          ],
        },
        {
          op: "if",
          cond: { k: "varEq", key: "mode", value: 0 },
          then: [
            {
              op: "choose",
              bind: "t",
              min: 0,
              max: 3,
              spec: { zone: "trash", enemy: true },
              prompt: "Choose up to 3 cards from opponents' trashes",
            },
            { op: "recycleTargets", to: "$t" },
          ],
          else: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Gentle Gemdragon": {
      triggers: [
        {
          on: "played",
          you: true,
          label: "Dragon played: ready up to 2 runes",
          condSpec: { k: "evTag", tag: "Dragon" },
          program: [
            {
              op: "choose",
              bind: "r",
              min: 0,
              max: 2,
              spec: { type: "rune", friendly: true, ready: false },
              prompt: "Ready up to 2 runes",
            },
            { op: "ready", to: "$r" },
          ],
        },
      ],
    },

    "Grim Resolve": {
      targets: [
        {
          bind: "t",
          spec: { type: "unit", friendly: true },
          prompt: "Give which friendly unit +3 Might this turn?",
        },
      ],
      play: [
        buff("$t", 3),
        {
          op: "delayed",
          on: "combatEnd",
          repeat: true,
          carry: ["t"],
          label: "Grim Resolve: it won a combat",
          program: [
            {
              op: "if",
              skip: 1,
              cond: {
                k: "and",
                conds: [
                  {
                    k: "count",
                    n: 1,
                    spec: {
                      type: "unit", friendly: true, here: true,
                      sameLocAs: "t", ignoreUntargetable: true,
                    },
                  },
                  {
                    k: "count",
                    n: 0,
                    cmp: "exactly",
                    spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true },
                  },
                ],
              },
            },
            { op: "xp", n: 2 },
          ],
        },
      ],
    },

    "Irresistible Faefolk": {
      triggers: [
        {
          on: "move",
          self: true,
          optional: true,
          label: "moved to a battlefield: pull an enemy unit here",
          condSpec: { k: "evToBf" },
          targets: [
            {
              bind: "e",
              spec: { type: "unit", enemy: true },
              prompt: "Move which enemy unit to this battlefield?",
            },
          ],
          program: [{ op: "move", to: "$e", dest: "here" }],
        },
      ],
    },

    "Kinkou Initiate": {
      play: [
        {
          op: "if",
          cond: {
            k: "totalMight",
            n: 5,
            spec: { type: "unit", friendly: true, other: true, ignoreUntargetable: true },
          },
          then: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Nidalee, Cat Form": {
      triggers: [
        {
          on: "combatEnd",
          selfBf: true,
          label: "win a combat: draw 1",
          condSpec: {
            k: "count",
            n: 0,
            cmp: "exactly",
            spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true },
          },
          program: [{ op: "draw", n: 1 }],
        },
      ],
    },

    "Poppy, Paragon": {
      play: [
        {
          op: "if",
          cond: { k: "scoreWithin", who: "opponent", within: 3 },
          then: [{ op: "ready", to: "source" }, { op: "xp", n: 3 }],
        },
      ],
    },

    "Rengar, Trophy Hunter": {
      playToEnemyBf: true,
    },

    "Wily Newtfish": {
      selfMightSpecs: [{ n: 1, cond: { k: "gainedXpThisTurn" } }],
      selfKwSpecs: [{ name: "ganking", value: null, cond: { k: "gainedXpThisTurn" } }],
    },

    "Voidreaver": {
      triggers: [{
        on: "combatEnd",
        label: "win a combat: gain 1 XP",
        program: [{
          op: "if",
          cond: {
            k: "and",
            conds: [
              { k: "count", spec: { type: "unit", friendly: true, here: true, ignoreUntargetable: true }, n: 1 },
              { k: "count", spec: { type: "unit", enemy: true, here: true, ignoreUntargetable: true }, n: 0, cmp: "exactly" },
            ],
          },
          then: [{ op: "xp", n: 1 }],
        }],
      }],
      abilities: [
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          costXp: 1,
          exhausts: true,
          label: "Spend 1 XP: Buff a unit",
          targets: [{ bind: "t", spec: { type: "unit" }, prompt: "Buff which unit?" }],
          program: [{ op: "buff", to: "$t" }],
        },
        {
          cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
          costXp: 2,
          exhausts: true,
          label: "Spend 2 XP: move an exhausted friendly unit to its base",
          targets: [{
            bind: "t",
            spec: { type: "unit", friendly: true, atBf: true, ready: false },
            prompt: "Move which exhausted friendly unit to its base?",
          }],
          program: [{ op: "move", to: "$t", dest: "base" }],
        },
      ],
    },

    "Keeper of the Hammer": {
      triggers: [{
        on: "hold",
        you: true,
        label: "hold: gain 1 XP",
        program: [{ op: "xp", n: 1 }],
      }],
      abilities: [{
        cost: { energy: 0, pips: 0, anyPower: 0, domains: null },
        costXp: 3,
        exhausts: true,
        label: "Spend 3 XP: Draw 1",
        targets: [],
        program: [{ op: "draw", n: 1 }],
      }],
    },

    "Keeper's Verdict": {
      targets: [{
        bind: "t",
        spec: { type: "unit", enemy: true, atBf: true },
        prompt: "Which enemy unit at a battlefield goes on top or bottom of its owner's deck?",
      }],
      play: [
        {
          op: "option",
          byOpponent: true,
          varKey: "kv",
          options: ["Top of my Main Deck", "Bottom of my Main Deck"],
          prompt: "Place it on the top or bottom of your Main Deck?",
        },
        {
          op: "if",
          cond: { k: "varEq", key: "kv", value: 0 },
          then: [{ op: "toDeck", to: "$t" }],
          else: [{ op: "toDeck", to: "$t", bottom: true }],
        },
      ],
    },

    "Imposing Challenger": {
      triggers: [{
        on: "move", self: true, optional: true,
        label: "I move: push an enemy unit here with less Might to another battlefield",
        targets: [{
          bind: "t",
          spec: { type: "unit", enemy: true, here: true, lessMightThanSource: true },
          prompt: "Move which enemy unit here to a different battlefield?",
        }],
        program: [{ op: "move", to: "$t", destType: "bf" }],
      }],
    },

    "Repulse": {
      targets: [
        {
          bind: "f", spec: { type: "unit", friendly: true, atBf: true },
          prompt: "Choose a friendly unit at a battlefield",
        },
        {
          bind: "t",
          spec: {
            zone: "chain", enemy: true, counterable: true,
            kinds: ["spell", "ability"],
            targetsMatching: { isBind: "f" },
            targetsNoneMatching: { type: "unit", friendly: true, notBind: "f" },
          },
          prompt: "Counter which enemy spell or ability?",
        },
      ],
      play: [{ op: "counter", to: "$t" }],
    },

    "Stare Down": {
      targets: [
        { bind: "f", spec: { type: "unit", friendly: true }, prompt: "Choose a friendly unit" },
        { bind: "b", spec: { zone: "battlefield" }, prompt: "Choose a battlefield" },
      ],
      play: [
        {
          op: "move", dest: "base",
          spec: { type: "unit", enemy: true, atBind: "b", lessMightThanBind: "f" },
        },
        { op: "xp", n: 1 },
      ],
    },

    "Arachnoid Horror": {
      playToEnemyBf: { enemyAlone: true },
      grantsPlayToEnemyBf: { enemyAlone: true },
    },

    "Elder Dragon": {
      lethalAnyDamage: [{ who: "enemy" }],
      play: [
        {
          op: "chooseEachLoc", bind: "t", min: 0, max: 1,
          spec: { type: "unit", enemy: true },
          prompt: "Deal 1 to up to one enemy unit",
        },
        { op: "deal", to: "$t", n: 1 },
      ],
    },

    "Kha'Zix, Evolving Hunter": {
      triggers: [{
        on: "attack", self: true, optional: true,
        label: "spend 3 XP: deal damage equal to my Might to an enemy unit here",
        condSpec: { k: "xp", n: 3 },
        targets: [{
          bind: "t", spec: { type: "unit", enemy: true, here: true },
          prompt: "Deal my Might to which enemy unit here?",
        }],
        program: [
          { op: "spendXp", n: 3, varKey: "kz" },
          {
            op: "if", cond: { k: "varEq", key: "kz", value: true },
            then: [{ op: "deal", to: "$t", n: "sourceMight" }],
          },
        ],
      }],
    },
  });
})();
